// @flow

import {
  ADD_MACHINE_SUCCESS,
  ALERT_LOGS_SUCCESS,
  ALL_LOGS_SUCCESS,
  MACHINES_SUCCESS,
  NO_OF_REQUEST_SUCCESS,
  SERVER_STATUS_SUCCESS,
  AUCTION_DETAILS_SUCCESS,
  BILLING_DETAILS_SUCCESS,
  CARD_DETAILS_SUCCESS,
  REPORTS_SUCCESS,
  FETCH_CARD_SWAP_LOGS_REQUEST,
  FETCH_CARD_SWAP_LOGS_SUCCESS,
  FETCH_CARD_SWAP_LOGS_FAILURE,
} from '.';

const initialState = {
  cardSwapLogs: [],
  totalVehicleInsideToday: 0,
  totalVehicleEnteredToday: 0,
  totalVehicleExitedToday: 0,
  totalMaterialDispatchedToday: 0,
  totalMaterialPriceDispatchedToday: 0,
  totalMaterialDispatchedYesterday: 0,
  totalMaterialPriceDispatchedYesterday: 0,
  totalMaterialDispatchedCurrentMonth: 0,
  totalMaterialPriceDispatchedCurrentMonth: 0,
  totalMaterialDispatchedLastMonth: 0,
  totalMaterialPriceDispatchedLastMonth: 0,
  totalMaterialDispatchedCurrentYear: 0,
  totalMaterialPriceDispatchedCurrentYear: 0,
  totalMaterialDispatchedLastYear: 0,
  totalMaterialPriceDispatchedLastYear: 0,
  timeSeries: {
    dates: [],
    totalWeight: [],
    totalPrice: [],
  },
};

export default function reducer(state: MachineStoreType = initialState, action: ActionType): MachineStoreType {
  switch (action.type) {
    case MACHINES_SUCCESS: {
      const {
        payload: { machines },
      } = action;
      return {
        ...state,
        machines,
      };
    }
    case REPORTS_SUCCESS: {
      const {
        payload: { reports },
      } = action;
      return {
        ...state,
        reports,
      };
    }
    case ADD_MACHINE_SUCCESS: {
      const {
        payload: { machine },
      } = action;
      return {
        ...state,
        machines: [machine, ...state.machines],
      };
    }
    case SERVER_STATUS_SUCCESS: {
      const {
        payload: { logs },
      } = action;

      return {
        ...state,
        ...logs,
      };
    }
    case NO_OF_REQUEST_SUCCESS: {
      const {
        payload: { logs },
      } = action;
      return {
        ...state,
        noOfRequest: {
          date: logs.noOfRequest.map((value) => value.date),
          success: logs.noOfRequest.map((value) => value.count),
          disrupt: logs.disrupt.map((value) => value.count),
          outage: logs.outage.map((value) => value.count),
        },
      };
    }
    case ALL_LOGS_SUCCESS: {
      const {
        payload: { logs },
      } = action;
      return {
        ...state,
        logs,
      };
    }
    case BILLING_DETAILS_SUCCESS: {
      const {
        payload: { billingDetails },
      } = action;
      return {
        ...state,
        stats: billingDetails,
      };
    }
    case AUCTION_DETAILS_SUCCESS: {
      const {
        payload: { auctionDetails },
      } = action;
      return {
        ...state,
        auctionDetails,
      };
    }
    case CARD_DETAILS_SUCCESS: {
      const {
        payload: { cardDetails },
      } = action;
      return {
        ...state,
        cardDetails,
      };
    }
    case ALERT_LOGS_SUCCESS: {
      const {
        payload: { logs },
      } = action;
      return {
        ...state,
        alertLogs: logs,
      };
    }
    case FETCH_CARD_SWAP_LOGS_REQUEST: {
      return {
        ...state,
      };
    }
    case FETCH_CARD_SWAP_LOGS_SUCCESS: {
      const {
        payload: { logs },
      } = action;
      return {
        ...state,
        cardSwapLogs: logs,
      };
    }
    case FETCH_CARD_SWAP_LOGS_FAILURE: {
      return {
        ...state,
        cardSwapLogs: [],
      };
    }
    default:
      return state;
  }
}
